module.exports = __webpack_public_path__ + "static/media/karel-jiranek-photo.7e71cfe2.jpg";